module.exports = __webpack_public_path__ + "static/media/bread-slice.15d0b34f.svg";